import * as React from 'react';
import dayjs from 'dayjs';
import { Page, Grid, Card, Table, Button, Alert, Text } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import Request from '../../shared/request';
import './order.scss';
import i18n from '../../shared/i18n';

// const paidTypeNames = {
//   PROMOTION: '赠送',
//   YOUZAN: '支付',
//   WECHAT: '支付',
//   ALIPAY: '支付',
//   PAYPAL: '支付',
//   CARD: '充值卡',
//   REPAIR: '调整',
//   ADMIN: '手动调整',
//   BUY: '后台购买',
// };

class BindIndex extends PageComponent {
  state = {
    orderCount: null,
    orderList: [],
  };

  async componentDidMount() {
    const resOrders = await Request.call('getOrders');
    if (resOrders) {
      this.setState({
        orderCount: resOrders.count,
        orderList: resOrders.list,
      });
    }
  }

  getOrderTable() {
    const { orderList, orderCount } = this.state;

    if (orderCount === null) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <Text align="center">Loading...</Text>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    let orderListItems = [];
    if (orderList) {
      orderListItems = orderList.map((item, i) => {
        if (item.vasInfo) {
          const { category, bandwidth, number } = item.vasInfo;
          return {
            key: i,
            item: [
              {
                content: dayjs(item.createdAt || item.paidAt).format(
                  'YYYY-MM-DD HH:mm',
                ),
              },
              {
                content: `${i18n.t('dash-vas-title')} ${category === 'device' ? '-' + i18n('dash-vas-device') : '-' + i18n('dash-vas-bandwidth')
                  }`,
              },
              {
                content: `${bandwidth ? `${bandwidth}Mb` : `${number}个`}`,
              },
            ],
          };
        }
        return {
          key: i,
          item: [
            {
              content: dayjs(item.createdAt || item.paidAt).format(
                'YYYY-MM-DD HH:mm',
              ),
            },
            {
              content: item.planId !== 'GAME' ? i18n.t('dash-user-turbo') : i18n.t('dash-user-game'),
            },
            {
              content: item.planDays ? `${item.planDays}` : '-',
            },
          ],
        };
      });
    }

    return  (
      orderCount ? 
      <Table
        responsive
        className="card-table table-vcenter text-nowrap order-tables"
        headerItems={[
          { content: i18n.t('dash-order-date') },
          { content: i18n.t('dash-order-type') },
          { content: i18n.t('dash-order-number') },
        ]}
        bodyItems={orderListItems}
      />
    : 
      <Alert type="primary" hasExtraSpace className="home-alert vip-alert">
        <div>{i18n.t('dash-order-tip')}</div>
        <div>
          <Button
            outline
            size="md"
            color="success"
            RootComponent="a"
            href="/buy?utm_source=dashboard&utm_medium=order"
            target="noopener noreferrer">
            {i18n.t('dash-nav-buy')}
          </Button>
        </div>
      </Alert>
    )
  }

  render() {
    return (
      <Page.Content className="page-order">
        <Card>
          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>{i18n.t('dash-btn-back')}</span>
            </Link>
            <Card.Title>{i18n.t('dash-order-list')}{this.state.orderCount}</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="body">{this.getOrderTable()}</div>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default BindIndex;
